import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import {environment} from '../../../environments/environment';


const _apiLink=environment.api;
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class CommonapiService {

  constructor(
    private http: HttpClient,    
  ) { }

  private extractData(res: Response) {
    let body = res;
    return body || { };
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }


  getData(_apiName): Observable<any> {
    console.log(_apiLink+_apiName);

    return this.http.get(_apiLink + _apiName).pipe(
      map(this.extractData));
  }

  postData(_apiName,_param): Observable<any> {
    //console.log(JSON.stringify(_param));
    return this.http.post<any>(_apiLink+_apiName, JSON.stringify(_param), httpOptions).pipe(
      tap((data) => data),
      catchError(this.handleError<any>('postdata'))
    );
  }

  postData1(_apiName,_param): Observable<any> {
    //console.log(JSON.stringify(_param));
    return this.http.post<any>('http://localhost:12895/'+_apiName, JSON.stringify(_param), httpOptions).pipe(
      tap((data) => data),
      catchError(this.handleError<any>('postData1'))
    );
  }
}
